module.exports = __webpack_public_path__ + "static/media/YB5M18_2.35ca369c.jpg";